import { Component, Input, EventEmitter, Output } from '@angular/core';
import { ApiError, MessageService } from '../../../core';
import { Nota } from '../nota';
import { NotaSearch } from '../nota-search';
import { NotaFilter } from '../filter';
import { NotaCrudHttpService, NotaSearchHttpService } from '../services';
import { take } from 'rxjs/operators';

@Component({
    selector: 'sgt-nota-cards',
    templateUrl: './nota-cards.component.html',
    styleUrls: ['./nota-cards.component.less']
})
export class NotaCardsComponent {
    isLoading: boolean;
    notas: NotaSearch[] = [];

    @Input() canEdit = true;
    @Input() canDelete = true;

    /** Evento após inserir uma nova nota */
    @Output() afterInsert = new EventEmitter<Nota>();
    /** Evento após editar uma nota */
    @Output() afterEdit = new EventEmitter<Nota>();

    constructor(private messageService: MessageService,
                private notaCrudHttpService: NotaCrudHttpService,
                private notaSearchHttpService: NotaSearchHttpService) { }


    search(filter: NotaFilter, offset = -1, limit = -1): Promise<void> {
        return new Promise<void>((resolve, reject) => {
            this.notas = [];
            this.isLoading = true;
            this.notaSearchHttpService.search(filter, offset, limit)
                .pipe(
                    take(1)
                )
                .subscribe(
                    notas => {
                        this.notas = notas;
                        resolve();
                    },
                    (error: ApiError) => reject(error),
                    () => this.isLoading = false
                );
        });
    }

    insert(nota: Nota) {
        this.notaCrudHttpService.insert(nota)
            .pipe(
                take(1)
            )
            .subscribe(
                response => {
                    this.save(response);
                    this.afterInsert.emit(response);
                },
                (error: ApiError) => this.messageService.error( error.cause, error.message, error)
            );
    }

    edit(nota: NotaSearch) {
        this.notaCrudHttpService.update(nota)
            .pipe(
                take(1)
            )
            .subscribe(
                response => {
                    this.save(response);
                    this.afterEdit.emit(response);
                },
                (error: ApiError) => this.messageService.error( error.cause, error.message, error)
            );
    }


    private save(nota: Nota) {
        if (!nota) {
            return;
        }

        const notaSearch = new NotaSearch(nota);
        const index = this.notas.findIndex(notaFilter => notaFilter.id == nota.id);
        if (index > -1) {
            this.notas[index]= notaSearch;
        }else {
            this.notas.unshift(notaSearch);
        }
    }

    delete(nota: NotaSearch) {
        if (!nota) {
            return;
        }

        this.messageService.confirm('Deseja realmente excluir a nota?').then((result) => {
            if (result) {
                this.notaCrudHttpService.delete(nota.id)
                    .subscribe(
                        () => {
                            this.messageService.success('', 'Nota excluída com sucesso');
                            const index = this.notas.findIndex(notaFilter => notaFilter.id == nota.id);
                            if (index > -1) {
                                this.notas.splice(index, 1);
                            }
                        },
                        (error: ApiError) => this.messageService.error(error.message, 'Ocorreu um erro ao excluir a nota', error)
                    );
            }
        });
    }
}
